var map = {
	"./Sonar-dark.svg": 500,
	"./Sonar.svg": 1208,
	"./ada-dark.svg": 9064,
	"./ada.svg": 6720,
	"./analysis.png": 7100,
	"./android-dark.svg": 2932,
	"./android.svg": 5492,
	"./assembly.png": 7532,
	"./c++.svg": 532,
	"./c.svg": 2748,
	"./c3.svg": 7340,
	"./carbon.png": 6972,
	"./circt.svg": 5516,
	"./clean.svg": 8402,
	"./cmake.svg": 9016,
	"./crystal-dark.svg": 7856,
	"./crystal.svg": 1207,
	"./cuda-dark.svg": 2032,
	"./cuda.svg": 1780,
	"./d.svg": 4852,
	"./dart.svg": 2304,
	"./dotnet.svg": 4696,
	"./erlang.svg": 4376,
	"./fortran.svg": 2332,
	"./fsharp.svg": 9088,
	"./gimple.svg": 5840,
	"./go.svg": 4136,
	"./haskell.png": 164,
	"./hlsl.png": 1300,
	"./hook-dark.png": 7316,
	"./hook.png": 4352,
	"./hylo.svg": 8452,
	"./ispc.png": 8960,
	"./java.svg": 5376,
	"./js.svg": 8152,
	"./julia.svg": 9456,
	"./kotlin.svg": 5932,
	"./llvm.png": 8028,
	"./mlir.svg": 9868,
	"./nim.svg": 3680,
	"./ocaml.svg": 9024,
	"./opencl-dark.svg": 5356,
	"./opencl.svg": 3208,
	"./pascal-dark.svg": 6580,
	"./pascal.svg": 4868,
	"./pony.svg": 6693,
	"./python.svg": 1713,
	"./racket.svg": 3264,
	"./ruby.svg": 4424,
	"./rust-dark.svg": 2456,
	"./rust.svg": 9244,
	"./scala.png": 9848,
	"./snowball.svg": 4428,
	"./solidity.svg": 4220,
	"./swift.svg": 5372,
	"./toit.svg": 3524,
	"./ts.svg": 4316,
	"./v.svg": 6236,
	"./vala.svg": 8192,
	"./zig.svg": 6993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9288;